import { IInquiries } from '@llws/lift-entity-interfaces';
import { Null, Equal, QueryStringCommandOptions } from '@/shared';
import { StoreBaseImplementation } from '@/shared/classes/store-base-implementation';

// Base store configuration
const adminGatewayResourcePath: string = '/website-api/inquiries';
const listViewName: string = '';
const showLogging: boolean = false;

const defaultGetListFilters: QueryStringCommandOptions = {
  relations: [
    {
      path: 'building',
      alias: 'building',
    },
    {
      path: 'prospect',
      alias: 'prospect',
    },
  ],
  where: [
    Equal('status', 'enabled'),
    Null('buildingId'),
  ],
};

const defaultGetSingleFilters: QueryStringCommandOptions = {};

// Instantiate the base store with the params
const base = new StoreBaseImplementation<IInquiries>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

// Extend StoreBaseImplementation object to add custom state/getters/mutations/actions.
export default {
  namespaced: base.namespaced, // 'inquiries/'

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,
  },
};
